export const gqlCacheTypePolicies = {
  Licenses: {
    merge: true,
  },
  LicenseTemplates: {
    merge: true,
  },
  Templates: {
    merge: true,
  },
  IpmpAccounts: {
    merge: true,
  },
  TIconsType: {
    merge: true,
  },
  UpgradePackages: {
    merge: true,
  },
  Settings: {
    merge: true,
  },
  System: {
    merge: true,
  },
  EssentialsQuery: {
    merge: true,
  },
  CentersQuery: {
    merge: true,
  },
  UserSettings: {
    merge: true,
  },
  Dashboard: {
    merge: true,
  },
  Dashboards: {
    merge: true,
  },
  VersionInfoType: {
    merge: true,
  },
  SuggestionsQuery: {
    merge: true,
  },
  AppCustomizationType: {
    merge: true,
  },
};
